import { useCurrentPrototype } from "../useCurrentPrototype";

import { StatusSelector } from "./StatusSelector";

export const InfoPanel: React.FC = () => {
  const currentPrototype = useCurrentPrototype();

  return (
    <div className="w-56 rounded-xl border border-[#2a2a2a] bg-[#141414] p-4 shadow-[0_2px_8px_rgba(0,0,0,0.25)]">
      <h3 className="mb-3 text-[13px] font-semibold text-(--slate-color-action-text-inverse)">
        {currentPrototype?.name ?? "Prototype"}
      </h3>
      <div className="space-y-2.5">
        {(
          [
            ["Creator", currentPrototype?.owner ?? "Unknown"],
            ["Created", currentPrototype?.createdAt ?? "—"],
            ["Updated", currentPrototype?.lastUpdated ?? "—"],
            ["Surface", currentPrototype?.surfaceArea ?? "—"],
          ] as const
        ).map(([k, v]) => (
          <div key={k}>
            <div className="text-[10px] font-medium tracking-wide text-[#aaa] uppercase">
              {k}
            </div>
            <div className="text-[12px] text-[#ddd]">{v}</div>
          </div>
        ))}
        <StatusSelector />
      </div>
    </div>
  );
};
